import gql from 'graphql-tag';

export default gql`
  mutation UpdatePlan($image: String, $google_maps_url: String) {
    updatePlan(image: $image, google_maps_url: $google_maps_url) {
      id
      image
      google_maps_url
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/plan/update.js